import { ReactNode, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { TopBar } from "./TopBar";
import { MobileNav } from "./MobileNav";
import { useAuth } from "@/auth/auth-context";
import { SubscriptionExpiryBanner } from "./SubscriptionExpiryBanner";
import { ExpiredWorkspaceScreen } from "./ExpiredWorkspaceScreen";

export function AppLayout({ children }: { children?: ReactNode }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isNonPaying = user?.isPaying === false;
  const isExpired = isNonPaying && user?.subscriptionExpired === true;
  const showUpgradeRoute = location.pathname.startsWith("/upgrade-plan");
  const showExpiryBanner =
    !isExpired &&
    isNonPaying &&
    typeof user?.subscriptionSecondsUntilExpiry === "number" &&
    user.subscriptionSecondsUntilExpiry > 0 &&
    user.subscriptionSecondsUntilExpiry <= 48 * 60 * 60;

  if (isExpired && !showUpgradeRoute) {
    return <ExpiredWorkspaceScreen />;
  }

  return (
    <div className="flex min-h-screen w-full bg-background">
      <AppSidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar onMenuToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
        <main className="flex-1 overflow-x-clip p-4 pb-20 md:p-6 md:pb-6">
          <div className="mx-auto w-full max-w-[1400px]">
            {showExpiryBanner && typeof user?.subscriptionSecondsUntilExpiry === "number" ? (
              <SubscriptionExpiryBanner
                secondsUntilExpiry={user.subscriptionSecondsUntilExpiry}
                onUpgrade={() => navigate("/upgrade-plan")}
              />
            ) : null}
            {children ?? <Outlet />}
          </div>
        </main>
      </div>
      <MobileNav />
    </div>
  );
}
